import Api from './Api';
import { Entity } from '../../model/intent/types';

class EntitiesApi extends Api {
  constructor(baseUrl: string, headers: any) {
    super(baseUrl, '/Entities', headers);
  }

  get = (botId: string) => this.instance.get(`/${botId}`);

  create = (botId: string, entity: Entity) => this.instance.post(`/${botId}`, entity);

  update = (botId: string, entity: Entity) => this.instance.put(`/${botId}/${entity.id!}`, entity);

  delete = (botId: string, entityId: string) => this.instance.delete(`/${botId}/${entityId}`);
}

export default EntitiesApi;
